import http from "./http";
export default (carId) => ({
  async index(filters) {
    return http
      .index("cars", filters)
      .then((json) => ({ cars: json }))
      .catch(async (e) => ({ cars: null, error: await e }));
  },
  async get() {
    return http
      .get("cars", carId)
      .then((json) => ({ car: json }))
      .catch(async (e) => ({ car: null, error: await e }));
  },
  async create(data) {
    return http
      .post("cars", data)
      .then((json) => ({ car: json }))
      .catch(async (e) => ({ car: null, error: await e }));
  },
  async update(data) {
    return http
      .put("cars", carId, data)
      .then((json) => ({ car: json }))
      .catch(async (e) => ({ car: null, error: await e }));
  },
  async delete() {
    return http
      .delete("cars", carId)
      .then((json) => ({ car: json }))
      .catch(async (e) => ({ car: null, error: await e }));
  },
  Control: (controlId) => ({
    async index(filters) {
      const url = carId ? `cars/${carId}/controls` : `controls`;
      return http
        .index(url, filters)
        .then((json) => ({ controls: json }))
        .catch(async (e) => ({ controls: null, error: await e }));
    },
    async get() {
      return http
        .get(`cars/${carId}/controls`, controlId)
        .then((json) => ({ control: json }))
        .catch(async (e) => ({ control: null, error: await e }));
    },
    async create(data) {
      return http
        .post(`cars/${carId}/controls`, data)
        .then((json) => ({ control: json }))
        .catch(async (e) => ({ control: null, error: await e }));
    },
    async update(data) {
      return http
        .put(`cars/${carId}/controls`, controlId, data)
        .then((json) => ({ control: json }))
        .catch(async (e) => ({ control: null, error: await e }));
    },
    async delete() {
      return http
        .delete(`cars/${carId}/controls`, controlId)
        .then((json) => ({ control: json }))
        .catch(async (e) => ({ control: null, error: await e }));
    },
  }),
  ControlCategory: (categoryId) => ({
    async index(filters) {
      return http
        .index(`controls/categories`, filters)
        .then((json) => ({ categories: json }))
        .catch(async (e) => ({ categories: null, error: await e }));
    },
    async get() {
      return http
        .get(`controls/categories`, categoryId)
        .then((json) => ({ category: json }))
        .catch(async (e) => ({ category: null, error: await e }));
    },
    async create(data) {
      return http
        .post(`controls/categories`, data)
        .then((json) => ({ category: json }))
        .catch(async (e) => ({ category: null, error: await e }));
    },
    async update(data) {
      return http
        .put(`controls/categories`, categoryId, data)
        .then((json) => ({ category: json }))
        .catch(async (e) => ({ category: null, error: await e }));
    },
    async delete() {
      return http
        .delete(`controls/categories`, categoryId)
        .then((json) => ({ category: json }))
        .catch(async (e) => ({ category: null, error: await e }));
    },
  }),
});
